<template slot="header">

  <div class="ti-table bc-gray"
       v-bind:class="getSizeClasses()"
       v-b-tooltip.hover
       v-b-tooltip.nofade="getTooltipText"
       v-if="getIsAvailable"
       @click="handleClick"
       >

    <div class="ti-headerrow ti-cell grd"
         v-bind:class="{ ti_bg: isHeader, ti_bg_lite: !isHeader }">
      <div class="over">
        <p v-bind:class="{ narrow_05: isNarrow, narrow_10: isVeryNarrow, localheading: isHeader }">
          <font-awesome-icon name="fa-thumbs-up" icon="star" v-if="hasStar"></font-awesome-icon>
          {{ getKpiName }}
        </p>
      </div>
      <div class="tiny narrow_05" v-if="hasYtdValue(kpi)">
        YTD: {{ getYtdValue(kpi).Result }}
      </div>
    </div>

    <div class="ti-row">
      <div class="ti-cell">
        <performanceitem  :invertArrow="invertArrow"
                          :isHeader="isHeader"
                          :overallByWave="overallByWave"
                          :kpi="getEffectiveKpi"
                          :isLostLead="isLostLead"
                          :showPrewaves="showPrewaves"
                          :showInlineYtd="showInlineYtd"
                          :monochrome="monochrome"
                          :isBMWMoto="isBMWMoto" />
      </div>
    </div>

    <div v-if="showNpsBar">
      <npsbar :kpi="kpi" />
    </div>
  </div>

</template>


<script>
  import EventBus from '@/services/EventBus.js'
  import npsbar from '@/components/Dashboard-bmw/NpsBar';
  import performanceitem from './PerformanceItem2020';
  import ytdMixin from '@/mixins/YearToDateMixin.js';
  import KpiItemMixin from '@/mixins/bmw/KpiItemMixin.js';

  export default {
    name: 'KpiItem2020',
    
    components: {
      performanceitem,
      npsbar
    },
    
    mixins: [ ytdMixin, KpiItemMixin ],
    
    data() {
      return {
        lockedText: undefined
      }
    },

    methods: {
      handleClick(event) {
        EventBus.$emit('Modal-Kpi-Questions', { visible: true, kpi: this.kpi });
      }
    }
  };

</script>

<style scoped>
  p {
    color: black;
  }
  .grd {
    display: grid;
    grid-template-columns: 138fr 32fr; /* fraction*/
  }
  .localheading {
     font-size: 12pt;
  }
  .narrow {
    letter-spacing: -0.05em;
    width: 160px;
  }
  .over {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  dic.ti-cell{
    align-content: center;
    align-content: space-around;
  }
  p{
    font-size: 8pt;
    font-weight: bold;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    margin-left: 3px;
  }
  .tiny {
    color: black;
    font-size: 7pt;
    font-stretch: extra-condensed;
    margin-bottom:0px;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
    top: -2px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
  }

</style>
